import { render, staticRenderFns } from "./EditResCommunityManagement.vue?vue&type=template&id=652cd00e&scoped=true"
import script from "./EditResCommunityManagement.vue?vue&type=script&lang=js"
export * from "./EditResCommunityManagement.vue?vue&type=script&lang=js"
import style0 from "./EditResCommunityManagement.vue?vue&type=style&index=0&id=652cd00e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652cd00e",
  null
  
)

export default component.exports